// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__kqj-L","meals-appear":"AvailableMeals_meals-appear__+5R2q"};